import * as React from "react";
import { Box } from "@mui/material";
import img from "../assets/img/flash image 4.png";

export default function SingleImageHero() {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        overflow: "hidden",
        height: { xs: 260, sm: 340, md: 420, lg: 620 },
        bgcolor: "#0b0b0b",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Background overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 0,
          background:
            "radial-gradient(1200px 500px at 50% 40%, rgba(255,255,255,0.06) 0%, rgba(0,0,0,0.78) 70%), linear-gradient(90deg, rgba(0,0,0,0.70) 0%, rgba(0,0,0,0.25) 50%, rgba(0,0,0,0.70) 100%)",
        }}
      />

      {/* IMAGE */}
      <Box
        component="img"
        src={img}
        alt="hero"
        draggable={false}
        sx={{
          zIndex: 1,

          /* ✅ WIDTH LOGIC */
          width: {
            xs: "100%",   // mobile contained
            sm: "100%",  // tablet full width
            md: "100%",  // tablet full width
            lg: "100%",  // desktop full width
          },

          /* ✅ HEIGHT LOGIC */
          height: {
            xs: "auto",
            sm: "100%",
            md: "100%",
            lg: "100%",
          },

          maxWidth: {
            xs: 360,
            sm: "none",
            md: "none",
            lg: "none",
          },

          /* ✅ FIT */
          objectFit: {
            xs: "contain", // mobile
            sm: "cover",   // tablet
            md: "cover",   // tablet
            lg: "cover",   // desktop
          },

          objectPosition: "center",

          /* ✅ STYLE */
          borderRadius: {
            xs: 16,
            sm: 0,
            md: 0,
            lg: 0,
          },

          filter: {
            xs: "drop-shadow(0 18px 45px rgba(0,0,0,0.45))",
            sm: "none",
            md: "none",
            lg: "none",
          },
        }}
      />
    </Box>
  );
}
